import { createSelector } from 'reselect';

const cottagesSelector = createSelector(
  (state) => state.cottages,
  (cottages) => cottages,
);

export const isFetching = createSelector(
  cottagesSelector,
  (cottages) => cottages.isFetching,
);

export const data = createSelector(
  cottagesSelector,
  (cottages) => cottages.data,
);

const getStat = (state, id) => cottagesSelector(state).stats[id];

export const statsViews = createSelector(
  getStat,
  (stat) => stat && stat.total,
);

export const statsRows = createSelector(
  getStat,
  (stat) => stat && stat.rows,
);

export const statsIsLoading = createSelector(
  getStat,
  (stat) => stat && stat.isLoading,
);

export const tagsSelector = createSelector(cottagesSelector, (c) => c.tags);

export default cottagesSelector;
